module.exports = "https://static.futunn.com/components/common-offline-activity-session/images/success.d912c4e36d.png";